module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid4.cfbd9f11.png";